module.exports = __webpack_public_path__ + "static/media/lease2_img6.f6949987.jpg";